"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.declineAgendaSlotReservationManyApiResponseSchema = void 0;
const zod_1 = require("zod");
exports.declineAgendaSlotReservationManyApiResponseSchema = zod_1.z.object({
    success: zod_1.z.boolean(),
});
